<template>
  <aside class="sidebar">
    <div class="row mr-0">
      <div class="col-12 hello-text mt-4 ml-1">
        Hola {{ this.name }}
      </div>
    </div>
    <div class="row">
      <div class="col-12 hello-text-sub ml-1">
        Esta es tu información de:
      </div>
    </div>
    <div class="row mt-3 ml-3">
      <div class="nav nav-pills nav-items pt-2 custom-width" id="v-pills-tab" role="tablist" aria-orientation="vertical">
        <a v-for="item in items"
          @click="handleClick(item.name)"
          :class="[item.active ? 'router-link-exact-active' : '']"
          class="nav-link mb-2"
          role="tab"
          aria-controls="v-pills-home"
          :id="item.id"
          :key="item.id">
          <img :src="item.icon" v-bind:alt="item.name">
          <span class="ml-2" :class="[item.active ? 'router-link-exact-active pointer' : 'custom-item-text pointer']">
            {{item.title}}
          </span>
          <span v-if="item.active" class="fad fa-chevron-right float-right mt-1 pointer"></span>
        </a>
      </div>
    </div>
  </aside>
</template>
<script>

export default {
  name: "sidebar",
  props: ['disabled','active', 'name'],
  data: () => ({
    entity: {},
    current: "",
    items: [
      {
        title: "Tus licencias médicas",
        name: "licenses",
        icon: "/img/lm-icon.png",
        url: "#",
        active: false,
        id: 'd-licenses'
      },
      {
        title: "Tus próximas citas",
        name: "reservations",
        icon: "/img/am-icon.png",
        url: "#",
        active: false,
        id: 'd-reservations'
      },
      {
        title: "Tus recetas médicas",
        name: "prescription",
        icon: "/img/rm-icon.png",
        url: "#",
        active: false,
        id: 'd-prescription'
      },
      {
        title: "Tus bonos emitidos",
        name: "bonoHistory",
        icon: "/img/be-icon.png",
        url: "#",
        active: false,
        id: 'd-bono-history'
      },
      {
        title: "Tu historial GES",
        name: "gesNotification",
        icon: "/img/ng-icon.png",
        url: "#",
        active: false,
        id: 'd-gest-notification'
      },
      {
        title: "Tu historial de horas",
        name: "history",
        icon: "/img/thh_icon.svg",
        url: "#",
        active: false,
        id: 'd-history'
      },
    ]
  }),

  methods: {
    handleClick(name){
      const path = window.location.pathname;
      if (!this.disabled) {
        window.location.href = `/mimed/${name}`;
        return;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.pointer{
  cursor: pointer;
}
.row {
  margin-left: 0px;
}
.custom-width{
  width: 100% !important;
}
.custom-item-text{
  font-family: "Poppins", sans-serif;
  font-size: 13px;
  font-weight: 450;
  color: #fafcfe;
}
.sidebar {
  position: sticky;
  background-color: #092f6d;
  width: 300px !important;
  .nav-items {
    flex-direction: column !important;
  }
}

.avatar-entity-sidebar {
  width: 32px;
  height: 32px;
  object-fit: cover;
}

.main-wrapper .sidebar{
  grid-column: 1/4;
  grid-row: 1/2;
  max-height: 100% !important;
  position: sticky;
  top: 20px;
  margin-right: 30px;
  width: 280px;
}
@media screen and (max-width: 768px) {

}

@media screen and (max-width: 991px) {
  .sidebar {
    height: 100vh;
    position: absolute;
    z-index: 1040;
    background-color: #fff;
    width: 100%;
    top: 0;

    .sidebar-entity {
      box-shadow: none !important;
      border-radius: 0;
    }

    .sidebar-title {
      padding-left: 1rem;
    }
  }
    .nav-link {
    border-radius: 0;
    padding: 0.875rem 1.5rem;
    border-bottom: 1.5px solid transparent;
    margin-bottom: 0;

    &.router-link-exact-active {
      background: transparent;
    }
  }

}

.hello-text{
  font-family: "Poppins", sans-serif;
  font-size: 22px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.14px;
  color: #ffffff;
}

.hello-text-sub{
  font-family: "Poppins", sans-serif;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.1px;
  color: #ffffff;
}

.nav-link {
  padding: 0.75rem 1rem;
  margin-bottom: 0.5rem;
  color: #092f6d;

  &.router-link-exact-active {
    background: #092f6d;
    font-family: "Poppins", sans-serif;
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: -0.08px;
    color: #092f6d !important;
    border-radius: 4px;
    background-color: #edf8ff;
    width: 87%;
    &
    .icon-link {
      color: #092f6d !important;
    }
  }
}

.sidebar-entity {
  .nav-link {
    border-radius: 0;

    &.router-link-exact-active {
      background: rgba(#37a56d, 0.1);
      color: #05c08a;

      &:hover {
        background: rgba(#37a56d, 0.3) !important;
      }

      .icon-link {
        color: #05c08a;
      }
    }
  }
}

.icon-link {
  width: 1.5rem;
  font-size: 0.8rem;
  margin: 0 auto;
  color: #092f6d;

  &:active {
    color: #fff;
  }
}

@media screen and (max-width: 770px) {

}
</style>
